import { render } from "./forest_ploat.vue?vue&type=template&id=54d24396"
import script from "./forest_ploat.vue?vue&type=script&lang=js"
export * from "./forest_ploat.vue?vue&type=script&lang=js"

import "./forest_ploat.vue?vue&type=style&index=0&id=54d24396&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__